module.exports = __webpack_public_path__ + "img/kavalan-main.203da80d.jpg";